var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[_c('StandardChart',{attrs:{"input":_vm.userData,"showDownload":_vm.showDownload}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }